export const filesMenuData = translations => [
  {
    country: translations.unitedStates || 'United States',
    teams: [
      {
        name: translations.contactCenter || 'NRC Files',
        files: [
          {
            name: translations.retailerFiles || 'Retailer Files',
            componentKey: 'RetailerFilesDataGrid',
          },
        ],
      },
      {
        name: 'GCS',
        files: [
          {
            name: translations.gcsFiles || 'GCS Files',
            componentKey: 'GCSFilesDataGrid',
          },
        ],
      },
    ],
  },
];
